export const ACTION_TYPES = {
  LIST_FETCH_START: 'LIST_FETCH_START',
  LIST_FETCH_SUCCESS: 'LIST_FETCH_SUCCESS',
  LIST_FETCH_FAIL: 'LIST_FETCH_FAIL',
  LIST_RESET: 'LIST_RESET',

  ITEM_FETCH_START: 'ITEM_FETCH_START',
  ITEM_FETCH_SUCCESS: 'ITEM_FETCH_SUCCESS',
  ITEM_FETCH_FAIL: 'ITEM_FETCH_FAIL',

  ITEM_STATIC_FETCH_START: 'ITEM_STATIC_FETCH_START',
  ITEM_STATIC_FETCH_SUCCESS: 'ITEM_STATIC_FETCH_SUCCESS',
  ITEM_STATIC_FETCH_FAIL: 'ITEM_STATIC_FETCH_FAIL',

  ITEM_REMOVE_SUCCESS: 'ITEM_REMOVE_SUCCESS',

  NONE: 'NONE',
}
